const $ = require("jquery");
const slick = require("slick-carousel");
import MicroModal from 'micromodal'
import axios from "axios"
import {format} from "date-fns"
import Elementary from './../vendor/elementary'
const fitvids = require("fitvids");

const init = () => {

	const modal             = document.querySelector('[data-modal]')
	const modalHeading      = modal.querySelector('[data-modal-heading]')
	const modalContent      = modal.querySelector('[data-modal-content]')
	const triggerAttr       = 'data-modal-trigger'
	const loadingClass      = 'is-loading'
	let   currentModalEvent = null

	// Loop through modal triggers
	for (const trigger of document.querySelectorAll('[' + triggerAttr + ']')) {

		trigger.addEventListener('click', (e) => {
			
			e.preventDefault()
			
			// Get slug of event
			const slug = trigger.getAttribute(triggerAttr)

			// If opening modal for event that has already been loaded, don't get event content
			if (slug === currentModalEvent) {

				// Display modal
				MicroModal.show('info-modal')

			} else {

				// Remove existing content from modal and add loading class
				modalHeading.innerHTML = ''
				modalContent.innerHTML = ''
				modal.classList.toggle(loadingClass)
		
				// Get new title for modal from trigger
				const title = trigger.getAttribute('data-modal-title')
				modalHeading.innerHTML = title

				// Display modal
				MicroModal.show('info-modal')

				// Pass event slug to getEventContent function
				getEventContent(slug).then((response) => {

					console.log(response);
					
					modal.classList.toggle(loadingClass)
					modalContent.innerHTML = response.data.html

					// Run elementary on modal to get correct styles for modal content
					Elementary(modal)

					// Run fitvids on any videos in modal content
					fitvids(".figure--video .figure__media");

					initGallery();
				})
			}
		})
	}

	/**
	 * Gets content for an event using axios
	 * @param string slug Slug of event to get content for
	 * 
	 * @returns Promise
	 */
	const getEventContent = (slug) => {

		// Add reference for which event is getting loaded
		currentModalEvent = slug

		const url = new URL('/data/event-content', window.location.origin)

		// Url params
		url.searchParams.append('slug', slug) // Date to get timeslots for
		url.searchParams.append('cachebust', format(new Date(), 't')) // Cachebust param
		
		// Ajax call
		return axios.get(url.href)
	}

	const initGallery = () => {

		console.log('init gallery');

		const galleryCarousels = $("[data-carousel-gallery]");
		// Initialise carousel
		galleryCarousels.each(function() {
			let parentGallery = $(this).parents(".gallery");
			let paginationEl = parentGallery.find(".gallery__pagination");
			$(this).on("init reInit afterChange", function(
				e,
				slick,
				currSlide,
				nextSlide
			) {
				let i = (currSlide ? currSlide : 0) + 1;
				console.log(i);
				console.log(slick.slideCount);
				paginationEl.text(i + "/" + slick.slideCount);
			});
			$(this).slick({
				infinite: true,
				prevArrow:
					'<button type="button" class="btn btn--arrow btn--arrow-prev"><span>Prev</span></button>',
				nextArrow:
					'<button type="button" class="btn btn--arrow btn--arrow-next"><span>Next</span></button>',
				appendArrows: parentGallery.find(".gallery__controls"),
				slidesToShow: 2,
				responsive: [
					{
						breakpoint: 1240,
						settings: {
							slidesToShow: 1
						}
					}
				]
			});
		});
	}

	// Initialise MicroModal
	MicroModal.init()
}

export default function() {
    init();
}